import Cookies from "js-cookie";
import EnvironmentService from "./environmentService";


export default class MovieService {

    constructor() {
        this.environmentService = new EnvironmentService();
    }



 async GetMovies() {
        let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/movie/overview",
            {
                headers: {
                    "Authorization": "bearer " + Cookies.get("access_token")
                },
                method: "GET"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }

    }
async UploadMovieVariant(movieFile,movieUuid,languageVariant){

    let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/movie/upload",
    {
        headers: {
            "Authorization" : "bearer " + Cookies.get("access_token"),
            "language": languageVariant,
            "movieuuid" :movieUuid
        },
        body: movieFile,
        method: "POST"
    });
    let responseOK = result && result.ok;
    if (responseOK) {
        let data = await result.json();
        console.log(data);
    }
    else {
        console.log(result);
    }
}

async GetMovieVariants(movieUuid) {

        let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/movie/overview/variants?movieuuid="+ movieUuid ,
            {
                headers: {
                    "Authorization": "bearer " + Cookies.get("access_token")
                },
                method: "GET"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }

    }

    async RegisterMovie(movieName, date){
        let registerMovieObject ={
            name : movieName,
            releaseDate : date
        }
        let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/movie/register" ,
        {
            headers: {
                "Authorization": "bearer " + Cookies.get("access_token"),
                "Content-type": "application/json"
            },
            method: "POST",
            body: JSON.stringify(registerMovieObject)
        });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }

    }

    async GetMovieDetails(movieUuid) {

        let result = await fetch(this.environmentService.getAPIEnvironmentHost() + "/api/movie/"+movieUuid ,
        {
            headers: {
                "Authorization": "bearer " + Cookies.get("access_token")
            },
            method: "GET"
        });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }

    }

}